import { IndexContext } from "../../context/IndexContext";
import { useContext } from "react";

export function useShowMessage() {
  const { messageApi } = useContext(IndexContext);

  const showMessage = ({
    type = "error",
    apiType = null,
    message,
    extra = null,
    error = {},
  }) => {
    let content;

    switch (apiType) {
      case "response":
        if (error?.status == 403) {
          content = `Not allow to access: ${message}. Please Contact Admin. ${
            extra ? extra : ""
          }`;
        } else {
          content = `Failed to Respond: ${message}. Please Contact Admin. ${
            extra ? extra : ""
          }`;
        }
        break;
      case "fetch":
        content = `Network Error. Failed to ${message}.`;
        break;
      default:
        content = message;
        break;
    }

    messageApi.open({
      type: type,
      content: content,
    });
  };

  return showMessage;
}
